export default __webpack_public_path__ + "static/media/Nosotros_imagen1_1152.f543ca2a.jpg";